module.exports = __webpack_public_path__ + "static/media/certaResposta.8f1e336b.mp3";